export const defaultCurrency = 'KZT'

export default ['KZT', 'RUB', 'USD', 'EUR']
